import { render, staticRenderFns } from "./DeleteDomains.vue?vue&type=template&id=04ca3b17"
import script from "./DeleteDomains.vue?vue&type=script&lang=js"
export * from "./DeleteDomains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports